import React from 'react';
import { configAxios } from '../../../axiosUtils';
import { Crash } from '../../../components/crash/Crash';
import { CommonAppProviders } from './CommonAppProviders';
import { Commons } from './Commons';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

configAxios();

type Props = {
  children: React.ReactNode;
};

export class CommonApp extends React.Component<Props> {
  componentDidMount() {
    if (window.send_analytics_events) {
      window.send_analytics_events.forEach(analyticsEvents => {
        doctrineAnalytics(analyticsEvents.event, analyticsEvents.data);
      });
    }
  }

  render() {
    const { children } = this.props;
    return (
      <Crash>
        <CommonAppProviders>
          <Commons>{children}</Commons>
        </CommonAppProviders>
      </Crash>
    );
  }
}
